import * as Sentry from '@sentry/react'

type SafeJsonResult<T = unknown> =
	| { ok: true; data: T }
	| { ok: false; data: null }

export async function safeParseJson<T = unknown>(
	response: { json(): Promise<T> },
	context: string,
): Promise<SafeJsonResult<T>> {
	try {
		const data = await response.json()
		return { ok: true, data }
	} catch (error) {
		if (
			error instanceof SyntaxError &&
			error.message.includes('Unexpected end of JSON input')
		) {
			Sentry.addBreadcrumb({
				category: 'http',
				message: `Empty response body in ${context}`,
				level: 'warning',
			})
		} else {
			Sentry.captureException(error, {
				tags: { context },
			})
		}
		return { ok: false, data: null }
	}
}
